import {MyToastRequest} from '../../../helpers/MyToast'

export const mostrarRegistrosStock = async (data) => {

    const toastInfo = {
        endpoint: 'registrosstock/registrosRango',
        data: data,
        method: 'GET',
    }
    const resp =await MyToastRequest(toastInfo)
    return resp.result;
}

export const mostrarRegistrosImport = async (data) => {

    const toastInfo = {
        endpoint: 'registros/registrosRangoImp',
        data: data,
        method: 'GET',
    }
    const resp =await MyToastRequest(toastInfo)
    return resp.result;
}

export const mostrarRegistrosYonke = async (data) => {

    const toastInfo = {
        endpoint: 'registros/registrosRangoYonke',
        data: data,
        method: 'GET',
    }
    const resp =await MyToastRequest(toastInfo)
    return resp.result;
}

export const mostrarRegistrosStockFilt = async (data) => {

    const toastInfo = {
        endpoint: 'registrosstock/registrosRangoFilt',
        data: data,
        method: 'GET',
    }
    const resp =await MyToastRequest(toastInfo)
    return resp.result;
}

export const mostrarRegistrosImportFilt = async (data) => {

    const toastInfo = {
        endpoint: 'registros/registrosRangoImpFilt',
        data: data,
        method: 'GET',
    }
    const resp =await MyToastRequest(toastInfo)
    return resp.result;
}

export const mostrarRegistrosYonkeFilt = async (data) => {

    const toastInfo = {
        endpoint: 'registros/registrosRangoYonkeFilt',
        data: data,
        method: 'GET',
    }
    const resp =await MyToastRequest(toastInfo)
    return resp.result;
}











